<div
  #dropdownDownloads="ngbDropdown"
  class="dropdown d-inline-block"
  ngbDropdown>
  <button
    id="page-header-downloads-dropdown"
    type="button"
    class="btn header-item noti-icon"
    ngbDropdownToggle>
    <i class="bx bxs-download font-size-28"></i>
    <span
      class="badge rounded-pill"
      [ngClass]="{
        'bg-light': total === 0,
        'bg-primary': total > 0 && !loading,
        'bg-warning': loading
      }">
      <ng-container *ngIf="!loading; else onLoading">
        {{ total }}
      </ng-container>
      <ng-template #onLoading>
        <i class="bx bx-hourglass font-size-10 text-white"></i>
      </ng-template>
    </span>
  </button>

  <div
    class="dropdown-menu dropdown-mega-menu-xl dropdown-menu-end p-0"
    ngbDropdownMenu
    aria-labelledby="page-header-downloads-dropdown">
    <div class="p-3">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="m-0">Downloads</h6>
        </div>
        <div class="col-auto">
          <button class="btn btn-light-2" disabled>
            <b>{{ ready }}</b> Downloads Ready
          </button>
        </div>
      </div>
    </div>

    <app-ngx-simplebar
      style="position: relative; height: 500px; overflow-x: hidden">
      <div class="p-3">
        <ng-container *ngIf="downloads.length > 0; else empty">
          <div
            class="row py-3 border-bottom align-items-center"
            *ngFor="let batch of downloads">
            <div class="col">
              <div class="d-flex flex-column">
                <div class="mb-2" *ngIf="batch.isBatchInd">
                  <span
                    class="badge bg-primary rounded-pill px-2 bg-opacity-10 text-dark font-size-16">
                    <i class="bx bx-folder"></i>
                    Batch
                  </span>
                </div>
                <div class="">
                  <h6 class="text-tso-life-secondary-color">
                    {{ batch.title }}
                  </h6>
                </div>
                <div class="">
                  <p class="m-0">
                    {{ mm(batch.createdAt).format('MM/DD/YYYY [at] hh:mm A') }}
                  </p>
                </div>
                <div class="">
                  <a
                    href="javascript: void(0);"
                    (click)="onRemove(batch)"
                    class="text-danger">
                    Remove
                  </a>
                </div>
              </div>
            </div>
            <div class="col-auto" [style.width]="'150px'">
              <div class="d-flex flex-column gap-2 justify-content-center">
                <span class="">
                  <button
                    class="btn btn-sm btn-light-2"
                    disabled
                    style="width: auto">
                    {{ batch.extension }}
                  </button>
                </span>

                <button
                  class="btn d-flex align-items-center justify-content-center"
                  [ngClass]="batch.buttonClass"
                  [disabled]="batch.disabled"
                  (click)="download(batch)">
                  <i
                    class="font-size-20 me-1 my-0"
                    [ngClass]="batch.buttonIcon"></i>
                  {{ batch.button }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #empty>
          <div
            role="alert"
            class="alert alert-light d-flex align-items-center gap-2 mb-4">
            <i
              class="bx bx-info-circle bx-align-middle align-middle font-size-24"></i>
            <div>
              <h5 class="m-0">No Pending Downloads</h5>
              <p class="m-0">You have no downloads ready</p>
            </div>
          </div>
        </ng-template>
      </div>
    </app-ngx-simplebar>

    <div class="p-3 border-top">
      <div class="row">
        <div class="col-auto">
          <button
            class="btn btn-soft-danger"
            (click)="onRemoveAll()"
            [disabled]="downloads.length === 0">
            <i class="bx bx-x"></i>
            Remove All
          </button>
        </div>
        <div class="col">
          <button
            type="button"
            (click)="viewAll()"
            class="btn btn-soft-primary w-100">
            View All
            <i class="bx bx-right-arrow-alt"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #allModal let-modal>
  <div class="modal-body text-center py-4">
    <h3>Remove All Print Downloads?</h3>
    <p>
      Are you sure you want to remove all print downloads?
      <br />
      This will remove all downloads, including pending downloads, from the
      list.
    </p>
    <div class="row g-3 justify-content-center">
      <div class="col-auto">
        <button class="btn btn-light-2" (click)="modal.dismiss()">
          Cancel
        </button>
      </div>
      <div class="col-auto">
        <button class="btn btn-danger" (click)="onRemoveAllApi()">
          Yes, Remove All
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #batchModal let-modal>
  <div class="modal-body text-center py-4">
    <h3>Remove Batch Download?</h3>
    <p>
      Are you sure you want to remove this batch download?
      <br />
      This will remove all downloads that are part of this batch.
    </p>
    <div class="row g-3 justify-content-center">
      <div class="col-auto">
        <button class="btn btn-light-2" (click)="modal.dismiss()">
          Cancel
        </button>
      </div>
      <div class="col-auto">
        <button class="btn btn-danger" (click)="onRemoveApi(selectedBatch)">
          Yes, Remove Batch Download
        </button>
      </div>
    </div>
  </div>
</ng-template>
